/* ══════════════════════════════════════════════════════════════════════════
   BBF SLIDER INDICATORS

   Finds every BBF horizontal strip and hangs a row of bars underneath it.
   The sections are not modified: they already share a small set of scroller
   classes, and attaching here means one implementation instead of twelve.

   Three things worth knowing:

   - It hides itself when the strip is not scrollable. Several of these
     classes become a grid at desktop (.bbf-fp__items, .bbf-fam, .bbf-strip),
     and a strip with nothing to scroll must not show an indicator. This is
     re-checked on resize, so switching Grid/Slider is handled for free.

   - One bar per card up to eight, then it switches to one bar per screenful.
     A row of fourteen bars stops being a position indicator and becomes
     noise.

   - Position is read from getBoundingClientRect, not offsetLeft, because
     these strips carry asymmetric padding and are not always their own
     offsetParent.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  var SELECTORS = [
    '.bbf-fp__items',   /* Feature + product — card slider          */
    '.bbf-hicd__strip', /* How it compares · Scents — scent strip   */
    '.bbf-fam',         /* Scent families                           */
    '.bbf-strip',       /* Ritual, review snippets, PDP frames      */
    '.bbf-gal__strip',  /* PDP gallery — dual carousel              */
    '.bbfc__rail'       /* Compare fragrances — slide rail          */
  ].join(',');

  var MAX_DOTS = 8;

  function kidsOf(el) {
    return Array.prototype.filter.call(el.children, function (c) {
      return c.nodeType === 1 && !c.classList.contains('bbf-sdots');
    });
  }

  function padLeft(el) {
    return parseFloat(getComputedStyle(el).paddingLeft) || 0;
  }

  function init(el) {
    if (el.dataset.bbfSdots) return;
    el.dataset.bbfSdots = '1';

    var nav = document.createElement('div');
    nav.className = 'bbf-sdots';
    nav.hidden = true;
    el.parentNode.insertBefore(nav, el.nextSibling);

    var mode = 'item';
    var count = 0;
    var kids = [];

    function build() {
      kids = kidsOf(el);
      var scrollable = el.scrollWidth - el.clientWidth > 4;

      if (!scrollable) {
        nav.hidden = true;
        nav.innerHTML = '';
        count = 0;
        return;
      }

      var next = kids.length;
      mode = 'item';
      if (next > MAX_DOTS || next === 0) {
        mode = 'page';
        next = Math.max(1, Math.ceil(el.scrollWidth / Math.max(1, el.clientWidth)));
      }
      /* A single bar says nothing a shopper can act on. */
      if (next < 2) {
        nav.hidden = true;
        nav.innerHTML = '';
        count = 0;
        return;
      }

      nav.hidden = false;
      if (next === count) return;
      count = next;

      nav.innerHTML = '';
      for (var i = 0; i < count; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bbf-sdots__dot';
        b.setAttribute('aria-label', 'Go to ' + (mode === 'page' ? 'page ' : 'item ') + (i + 1) + ' of ' + count);
        b.dataset.i = String(i);
        b.addEventListener('click', onDot);
        nav.appendChild(b);
      }
      paint();
    }

    function onDot(e) {
      var i = parseInt(e.currentTarget.dataset.i, 10);
      if (mode === 'page') {
        el.scrollTo({ left: i * el.clientWidth, behavior: 'smooth' });
        return;
      }
      var target = kids[i];
      if (!target) return;
      /* scrollBy on the strip, not scrollIntoView — the latter will also
         scroll the page vertically to bring the strip into view. */
      var delta = target.getBoundingClientRect().left -
                  (el.getBoundingClientRect().left + padLeft(el));
      el.scrollBy({ left: delta, behavior: 'smooth' });
    }

    function activeIndex() {
      if (!count) return 0;
      if (mode === 'page') {
        return Math.min(count - 1, Math.max(0, Math.round(el.scrollLeft / Math.max(1, el.clientWidth))));
      }
      var origin = el.getBoundingClientRect().left + padLeft(el);
      var best = 0, bestDist = Infinity;
      kids.forEach(function (k, i) {
        var d = Math.abs(k.getBoundingClientRect().left - origin);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }

    function paint() {
      if (!count) return;
      var on = activeIndex();
      var dots = nav.children;
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-on', i === on);
      }
    }

    var ticking = false;
    el.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; paint(); });
    }, { passive: true });

    build();

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () { build(); paint(); });
      ro.observe(el);
    } else {
      window.addEventListener('resize', function () { build(); paint(); });
    }
  }

  function scan(root) {
    (root || document).querySelectorAll(SELECTORS).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  /* Theme editor: a re-rendered section arrives with fresh nodes. */
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
